import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { CheckCircle } from 'lucide-react';

const SubscriptionSuccessModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogTitle className="sr-only">Access activated</DialogTitle>
        <DialogDescription className="sr-only">Your MyInvestFolio access is now active. You can continue to the dashboard.</DialogDescription>
        <div className="text-center space-y-6 py-8">
          {/* Success Icon */}
          <div className="flex justify-center">
            <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-emerald-600" />
            </div>
          </div>

          {/* Header */}
          <div className="space-y-2">
            <h2 className="text-3xl font-serif font-bold text-slate-900">
              Access Activated
            </h2>
          </div>

          {/* Body */}
          <div className="space-y-4">
            <p className="text-xl font-semibold text-slate-700">
              Welcome to MyInvestFolio.
            </p>
            <p className="body-text text-base">
              Your account is now ready to securely manage and view your entire investment portfolio.
            </p>
          </div>

          {/* CTA Button */}
          <Button
            onClick={onClose}
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-6 text-lg"
          >
            Go to Dashboard
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SubscriptionSuccessModal;
